export const gameObjectTypesDefault = {
    DIVIDE_LINE: 'divide-line',
    CURBSTONE_SEPARATOR_LEFT: 'curbstone-separator-left',
    CURBSTONE_SEPARATOR_RIGHT: 'curbstone-separator-right'
};

const gameObjectTypes = {
    HUMMOCK_1_LEFT: 'hummock-1-left',
    HUMMOCK_1_RIGHT: 'hummock-1-right',
    SIGN_60_LEFT: 'sign-60-left',
    SIGN_60_RIGHT: 'sign-60-right',
    SIGN_MOOSE_LEFT: 'sign-moose-left',
    SIGN_MOOSE_RIGHT: 'sign-moose-right',
    BUSH_1_LEFT: 'bush-1-left',
    BUSH_1_RIGHT: 'bush-1-right',
    BUSH_2_LEFT: 'bush-2-left',
    BUSH_2_RIGHT: 'bush-2-right',
    BUSH_3_LEFT: 'bush-3-left',
    BUSH_3_RIGHT: 'bush-3-right',
    TREE_1_LEFT: 'tree-1-left',
    TREE_1_RIGHT: 'tree-1-right',
    TREE_2_LEFT: 'tree-2-left',
    TREE_2_RIGHT: 'tree-2-right',
    TREE_3_LEFT: 'tree-3-left',
    TREE_3_RIGHT: 'tree-3-right',
    TREE_4_LEFT: 'tree-4-left',
    TREE_4_RIGHT: 'tree-4-right',
    ROCK_1_LEFT: 'rock-1-left',
    ROCK_1_RIGHT: 'rock-1-right',
    ROCK_2_LEFT: 'rock-2-left',
    ROCK_2_RIGHT: 'rock-2-right',
    ROCK_3_LEFT: 'rock-2-left',
    ROCK_3_RIGHT: 'rock-2-right',
    ANIMAL_1_RIGHT: 'animal-1-right',
    ANIMAL_2_RIGHT: 'animal-2-right',
    REGION_LAKE: 'region-lake',
    REGION_1_SIGN: 'region-1-sign',
    REGION_1_BUILDING: 'region-1-building',
    REGION_2_SIGN: 'region-2-sign',
    REGION_3_SIGN: 'region-3-sign',
    REGION_3_BUILDING: 'region-3-building',
    REGION_5_SIGN: 'region-5-sign',
    REGION_7_BUILDING: 'region-7-building',
    REGION_7_SIGN: 'region-7-sign',
    REGION_8_SIGN: 'region-8-sign',
    SKIS_IN_SNOWDRIFT: 'skis-in-snowdrift',
    SLED_IN_SNOWDRIFT: 'sled-in-snowdrift',
    STUMP_RIGHT: 'stump-right',
    STUMP_LEFT: 'stump-left',
    MAIN_CHARACTER: 'main-character',
    LOOT_OBJECT: 'loot-object',
    ...gameObjectTypesDefault
};

export default gameObjectTypes;
